import * as React from 'react';

const TensorflowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_781_1291)">
            <path
                d="M15.8114 4.29883V8.59791L23.257 12.897V8.59791L15.8114 4.29883ZM0.919678 8.59791V12.897L4.64249 15.0461V10.7474L0.919678 8.59791ZM12.0881 10.7474L8.36531 12.897V25.7933L12.0881 27.9429V19.3452L15.8114 21.4947V17.1956L12.0881 15.0461V10.7474Z"
                fill="#E55B2D"
            />
            <path
                d="M15.8115 4.29883L4.64258 10.7474V15.0461L12.0882 10.7474V15.0461L15.8115 12.897V4.29883ZM26.9804 6.44837L23.2571 8.59791V12.897L26.9804 10.7474V6.44837ZM19.5343 15.0461L15.8115 17.1956V21.4947L19.5343 19.3452V15.0461ZM15.8115 21.4947L12.0882 19.3452V27.9429L15.8115 25.7933V21.4947Z"
                fill="#ED8E24"
            />
            <path
                d="M15.8114 0L0.919678 8.59771L4.64249 10.7473L15.8114 4.29864L23.257 8.59771L26.9803 6.44818L15.8114 0ZM15.8114 12.8968L12.0881 15.0459L15.8114 17.1954L19.5342 15.0459L15.8114 12.8968Z"
                fill="#F8BF3C"
            />
        </g>
        <defs>
            <clipPath id="clip0_781_1291">
                <rect fill="white" height="28" transform="translate(0.919678)" width="26.1606" />
            </clipPath>
        </defs>
    </svg>
);
export default TensorflowIcon;
